import { render, staticRenderFns } from "./qc-standards.vue?vue&type=template&id=0c992e5d&scoped=true"
import script from "./qc-standards.vue?vue&type=script&lang=js"
export * from "./qc-standards.vue?vue&type=script&lang=js"
import style0 from "./qc-standards.vue?vue&type=style&index=0&id=0c992e5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c992e5d",
  null
  
)

export default component.exports